import fetch from 'unfetch'

const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:9000/published/gql'

interface Options {
  input: any
  successCallback: (data: any) => void
  method?: string
  endPoint?: string
  errorCallback?: (data: any) => void
}

export default function fetch2(options: Options): any {
  const { method = 'POST', input, successCallback, errorCallback } = options
  fetch(GRAPHQL_ENDPOINT, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'x-referer': window.location.href,
      'x-screen-res': window.screen.width + ' x ' + window.screen.height,
    },
    body: JSON.stringify(input),
  })
    .then((response) => {
      if (response.ok) {
        return response
      }
      const error = new Error(response.statusText)
      return Promise.reject(error)
    })
    .then((response) => response.json())
    .then((data) => {
      if (!data?.errors || data.errors?.length === 0) {
        successCallback(data)
      } else {
        errorCallback?.(data?.errors)
      }
    })
}
